type Crumb = {
  /** Human-readable name shown in the breadcrumb trail. */
  name: string;
  /** Absolute URL for this step in the trail. Schema.org requires absolute. */
  url: string;
};

/**
 * Schema.org BreadcrumbList - used to help Google render the breadcrumb
 * trail in SERPs (rich results). Pass crumbs ordered from home to current
 * page; position numbers are assigned automatically.
 *
 * Example:
 *   buildBreadcrumbSchema([
 *     { name: 'Home', url: 'https://www.getgoingpt.com.au/' },
 *     { name: 'Learning Hub', url: 'https://www.getgoingpt.com.au/learning-hub/' },
 *     { name: 'Blog', url: 'https://www.getgoingpt.com.au/learning-hub/blog/' },
 *     { name: 'Why Male PTs Hate Leg Day', url: 'https://www.getgoingpt.com.au/learning-hub/blog/why-male-personal-trainers-hate-leg-day/' },
 *   ])
 */
export function buildBreadcrumbSchema(crumbs: Crumb[]): Record<string, any> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: crumb.name,
      item: crumb.url,
    })),
  };
}
